export enum ISOptimisationRecommendationEnum {
  CRITICAL = 'CRITICAL',
  IMPORTANT = 'IMPORTANT',
  MEDIUM = 'MEDIUM',
  NONE = 'NO_RECOMMENDATION',
  OPTIMISED = 'OPTIMISED',
}
